<template>
    <transition name="slide-fade">
        <div id="cookies-warning" v-cloak v-if="showMsg">
            <div class="d-flex justify-content-center flex-sm-row flex-column">
                <div>
                    <p class="font-weight-thin">OUR SITE USES COOKIES</p>
                    <p class="xxxsmall ls-07 font-weight-thin">If you continue to use our website you consent to the
                        use of cookies as stated in our
                        Cookie Policy.</p>
                </div>
                <button @click="setMsgCookie(false)" class="mt-sm-0 mt-3"><i class="icon-check"></i>OK, I UNDERSTAND</button>
            </div>
        </div>
    </transition>
</template>

<script>
    import VueCookies from 'vue-cookies'
    Vue.use(VueCookies)

    export default {
        components: {
            VueCookies
        },
        data() {
            return {
                showMsg: false
            }
        },
        methods: {
            getMsgCookie() {
                return (this.$cookies.get('showCookiesMsg') == 'true' || this.$cookies.get('showCookiesMsg') == null);
            },
            setMsgCookie(value) {
                this.$cookies.set('showCookiesMsg', value, '1m')
                this.showMsg = value
            },
        },
        mounted() {
            this.showMsg = this.getMsgCookie()
        },
    }
</script>

<style lang="scss">
    #cookies-warning {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px 10px;
        background: #353333;
        color: #fff;
        text-align: center;
        z-index: 999;
        -webkit-box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.55);
        box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.55);

        button {
            border: 1px solid #fff;
            padding: 5px 10px;
            color: #fff;
            margin-left: 20px;
            white-space: nowrap;
            font-weight: 100;

            i {
                font-size: 10px;
                margin-right: 10px;
            }
        }
    }

    .slide-fade-enter-active,
    .slide-fade-leave-active {
        transition: all 250ms ease-out;
    }

    .slide-fade-enter,
    .slide-fade-leave-to {
        transform: translateY(100%);
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/cookies-msg/cookies-msg.vue